export const ELLIPSIS = "...";
